<template>
	<ListDisplay
		heading-data-test="build-list-section-heading"
		empty-data-test="no-builds-message"
		:sectionTitle="sectionTitle"
		:sectionDescription="sectionDescription"
		:updateStatus="buildUpdateStatus"
		:continuationKey="continuationKey"
		:noItemsMessage="noBuildsMessage"
		:canLoadMore="canLoadMore"
		:dataLoaded="dataLoaded"
		:hasItems="!!buildList && buildList.length > 0"
		@retry="$emit('retry')"
	>
		<template #skeleton>
			<BuildCardSkeleton />
		</template>

		<template #items>
			<BuildCard
				v-for="build in buildList"
				:key="`${keyPrefix}-${build.BuildID}`"
				:buildID="build.BuildID"
				:buildData="build"
			/>
		</template>

		<template #loadMoreButton>
			<slot name="loadMoreButton">
				<v-btn
					variant="outlined"
					width="auto"
					:loading="buildUpdateStatus?.loading"
					@click="$emit('load-more-builds')"
				>
					Load more builds
				</v-btn>
			</slot>
		</template>
	</ListDisplay>
</template>

<script lang="ts">
import { Build } from "@/types/api/builds";
import { RemoteAccessState } from "@/types/general";
import { defineComponent, PropType } from "vue";

// Components
import ListDisplay from "@/components/TaskManager/ListDisplay.vue";
import BuildCard from "@/components/TaskManager/BuildCard.vue";
import BuildCardSkeleton from "@/components/TaskManager/BuildCardSkeleton.vue";

export default defineComponent({
	name: "BuildListDisplay",
	components: { ListDisplay, BuildCard, BuildCardSkeleton },
	props: {
		sectionTitle: { type: String, required: true },
		sectionDescription: { type: String, required: true },
		buildList: { type: Array as PropType<Build[]>, default: () => [] },
		buildUpdateStatus: { type: Object as PropType<RemoteAccessState> },
		continuationKey: { type: String },
		buildsLoadingMessage: { type: String, required: true },
		noBuildsMessage: { type: String, required: true },
		canLoadMore: { type: Boolean, default: false },
		keyPrefix: { type: String, default: "build" },
		dataLoaded: { type: Boolean, default: true },
	},
	emits: { "load-more-builds": () => true, retry: () => true },
});
</script>
